import { UserId } from '../../models/Base';
import { RepositoryElement } from '../../models/Repository';
import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';

export enum FollowershipState {
  Following = 'following',
  NotFollowing = 'notFollowing',
  NotInterested = 'notInterested',
  Blocked = 'blocked',
  Blocking = 'blocking',
}

export enum FollowershipRole {
  Root = 'root',
  Follower = 'follower',
}

export type FollowershipJson<T = number> = {
  rootId: UserId;
  userId: UserId;
  createdAt: T;
  lastModifiedAt: T;
  firstFollowedAt?: T;
  lastFollowedAt?: T;
  streamInSyncAt?: T;
  state: FollowershipState;
  role: FollowershipRole;
};

export class Followership
  extends RepositoryElement
  implements FollowershipJson<Date>
{
  rootId!: UserId;
  userId!: UserId;
  createdAt!: Date;
  lastModifiedAt!: Date;
  firstFollowedAt?: Date;
  lastFollowedAt?: Date;
  streamInSyncAt?: Date;
  state!: FollowershipState;
  role!: FollowershipRole;

  constructor(followership: FollowershipJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(followership));
  }

  id(): string {
    return `${this.rootId}_${this.userId}`;
  }

  toJSON(): FollowershipJson {
    return deepTransformDate(this) as unknown as FollowershipJson;
  }
}
